import { z } from 'zod';
import { CursorPageQuery, IsoDateTime, Uuid } from './common.js';
export const AuditActorType = z.enum(['USER', 'SYSTEM', 'PLATFORM']);
export const AuditEvent = z.object({
    id: Uuid,
    occurredAt: IsoDateTime,
    actorType: AuditActorType,
    actorUserId: Uuid.nullable(),
    actorName: z.string().nullable(),
    /** Action au format `domaine.action` (ex. `user.invite`, `role.update`, `auth.login_failed`). */
    action: z.string(),
    entityType: z.string(),
    entityId: z.string().nullable(),
    entityReference: z.string().nullable(),
    reason: z.string().nullable(),
    before: z.record(z.unknown()).nullable(),
    after: z.record(z.unknown()).nullable(),
    diff: z.record(z.unknown()).nullable(),
    ip: z.string().nullable(),
    userAgent: z.string().nullable(),
    traceId: z.string().nullable(),
});
export const ListAuditEventsQuery = CursorPageQuery.extend({
    entityType: z.string().optional(),
    entityId: z.string().optional(),
    actorUserId: Uuid.optional(),
    action: z.string().optional(),
    from: IsoDateTime.optional(),
    to: IsoDateTime.optional(),
});
//# sourceMappingURL=audit.js.map